import { createSelector } from 'reselect'
import { removeTrailingSlash } from '@offerzen/pinata'

const getLocation = state => state.router.location

export const urlPath = createSelector([getLocation], location => removeTrailingSlash(location.pathname))
export const previousLocation = createSelector([getLocation], location => location.state?.previousLocation)
